import {
  QaCommentsConfig as IQaCommentsConfig,
  QaConfig as IQaConfig
} from 'services/api-service'

type sortOption = 'RECENT' | 'OLDEST' | 'BEST' | 'MOST_ANSWERS' | 'LEAST_ANSWERS' |
                  'MOST_RECENT_ANSWER' | 'OLDEST_ANSWER'

type relatedQuestionDisplayOption = 'NONE' | 'INCLUDED' | 'SEPARATE'

export enum RelatedQuestionsDisplayTypes {
  NONE = 'NONE',
  INCLUDED = 'INCLUDED',
  SEPARATE = 'SEPARATE'
}


class QaCommentsConfig implements IQaCommentsConfig {
  constructor(config: IQaCommentsConfig) {
    this.initialPageSize = config.initialPageSize
    this.includeSyndicated = config.includeSyndicated
    this.limit = config.limit
    this.minCharacterCount = config.minCharacterCount
    this.minWordCount = config.minWordCount
    this.sortOrder = config.sortOrder
    this.truncateLength = config.truncateLength
    this.truncateAllowance = config.truncateAllowance
  }

  initialPageSize: number
  includeSyndicated: boolean
  limit: number
  minCharacterCount: number
  minWordCount: number
  sortOrder: 0 | 1
  // the number of characters more than truncateLength it is allowed to be before we
  // really do truncate for when we want default to be true, 2nd check makes sure we ignore
  // any value they might have given like 3 or abc
  truncateAllowance: number
  truncateLength: number
}

export class QaConfig implements IQaConfig {
  constructor(config: IQaConfig) {
    this.defaultSortOption = config.defaultSortOption
    this.defaultSortOptionName = config.defaultSortOptionName
    this.displayUserToolbar = config.displayUserToolbar
    this.enableLazyLoading = config.enableLazyLoading
    this.headingLevel = config.headingLevel || 2
    this.hideBestAnswer = config.hideBestAnswer
    this.initialPageSize = config.initialPageSize
    this.pageSize = config.pageSize
    this.relatedInitialPageSize = config.relatedInitialPageSize
    this.relatedPageSize = config.relatedPageSize
    this.relatedQuestionsDisplay = config.relatedQuestionsDisplay
    if (config.comments) {
      this.comments = new QaCommentsConfig(config.comments)
    } else {
      this.comments = {}
    }
    this.showCheckoutChatterOnQAWidget = config.showCheckoutChatterOnQAWidget
    this.sortOptions = config.sortOptions
    this.useShowMore = config.useShowMore
    this.widgetDivId = config.widgetDivId
  }

  comments: IQaCommentsConfig
  // for answers / replies
  defaultSortOption: sortOption
  // TODO: Deprecated, replaced with defaultSortOption. Remove after configurator release.
  defaultSortOptionName: sortOption
  displayUserToolbar: boolean
  enableLazyLoading: boolean
  headingLevel: number
  hideBestAnswer: boolean
  initialPageSize: number
  pageSize: number
  relatedInitialPageSize: number
  relatedPageSize: number
  relatedQuestionsDisplay: relatedQuestionDisplayOption
  showCheckoutChatterOnQAWidget: boolean
  sortOptions: string[]
  useShowMore: boolean
  widgetDivId: string
}

let defaultConfig: IQaConfig = {}
export function loadConfig(config: IQaConfig): void {
  defaultConfig = new QaConfig(config)
}
export { defaultConfig as default }
